import React from 'react';
import { Row, Col } from 'antd';
import BaseAllTimePage from '../../common/baseAllTimePage';
import Header from '../../common/allTimeHeader';
import MembersWidget from './members.js';
import PointsEarnedWidget from './pointsEarned.js';
import PrayingWidget from './praying.js';
import FastingWidget from './fasting.js';
import OvercomingWidget from './overcoming.js';
import GuestCardActivitiesWidget from './guestCardActivities.js';
import GoalsAndAveragesWidget from './goalsAndAverages.js';
import GroupComparisonWidget from './groupComparison.js';
import WidgetContainer from '../../common/widgetContainer';

export default class AllTimePage extends BaseAllTimePage {
  get widgetParams() {
    return {
      churchId: this.props.selectedChurch.id,
      timezone: this.props.selectedChurch.timezone
    }
  }

  get revivalParams() {
    return this.props.revivalWeeks.church.revival;
  }

  get header() {
    return (
      <Row className="statistics-page-header-row">
        <Col>
          <Header/>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <WidgetContainer header={this.header}>
        <MembersWidget {...this.widgetParams} position={{ xl: 0, lg: 0, md: 0 }} />
        <PointsEarnedWidget {...this.widgetParams} revivalDates={this.revivalParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <OvercomingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <GuestCardActivitiesWidget {...this.widgetParams} revivalDates={this.revivalParams} position={{ xl: 0, lg: 1, md: 0 }} />
        <GoalsAndAveragesWidget {...this.widgetParams} position={{ xl: 1, lg: 1, md: 0 }} />
        <FastingWidget {...this.widgetParams} position={{ xl: 2, lg: 0, md: 0 }} />
        <PrayingWidget {...this.widgetParams} revivalDates={this.revivalParams} position={{ xl: 1, lg: 0, md: 0 }} />
        <GroupComparisonWidget {...this.widgetParams} position={{ xl: 2, lg: 1, md: 0 }} />
      </WidgetContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/allTime/allTime.js